import { useState } from 'react';

import { Box, useMediaQuery, useTheme } from '@mui/material';
import { PaymentSheetListObj } from '../../../models/PaymentSheet';
import { PaymentSheetsDetailsDialog } from '../PaymentSheetDetailsDialog';
import { PaymentSheetsTable } from '../PaymentSheetTable';
import { usePaymentSheetsPageContext } from '../context/PaymentSheetPageContext';

export const PaymentSheetsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [viewItem, setViewItem] = useState<PaymentSheetListObj | undefined>(undefined);

  usePaymentSheetsPageContext();

  const handleViewItem = (item: PaymentSheetListObj) => {
    setViewItem(item);
  };

  const handleCloseDialogs = () => {
    setViewItem(undefined);
  };

  return (
    <Box sx={{ mt: isMobile ? 2 : 0 }}>
      <PaymentSheetsTable onView={handleViewItem} />
      {viewItem && <PaymentSheetsDetailsDialog item={viewItem} onClose={handleCloseDialogs} />}
    </Box>
  );
};
